import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "role-detail" }
const _hoisted_2 = { class: "role-detail-main" }
const _hoisted_3 = { style: {"height":"100%","line-height":"40px"} }
const _hoisted_4 = { style: {"height":"100%","line-height":"40px"} }
const _hoisted_5 = { style: {"height":"100%","line-height":"40px"} }
const _hoisted_6 = { style: {"height":"100%","line-height":"40px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_page_header, {
      onBack: _ctx.goBack,
      title: "返回上一级",
      content: "详情页面"
    }, null, 8 /* PROPS */, ["onBack"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        ref: "form",
        model: _ctx.updateModel,
        "status-icon": "",
        rules: _ctx.rules,
        "label-width": "100px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "客户账号" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.customer.userAccount), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "客户名",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                modelValue: _ctx.updateModel.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.updateModel.name) = $event)),
                autocomplete: "off",
                placeholder: "请输入客户名",
                maxlength: "10",
                minlength: "1"
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "联系人",
            prop: "contacts"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                modelValue: _ctx.updateModel.contacts,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.updateModel.contacts) = $event)),
                autocomplete: "off",
                placeholder: "请输入联系人",
                maxlength: "10"
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "手机号码",
            prop: "phoneNo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                modelValue: _ctx.updateModel.phoneNo,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.updateModel.phoneNo) = $event)),
                autocomplete: "off",
                maxlength: "11",
                minlength: "6",
                placeholder: "请输入手机号码"
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.updateModel.phonePrefix,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.updateModel.phonePrefix) = $event)),
                    style: {"width":"100px"},
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryAreaCodes, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.text), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "value"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "地址",
            prop: "address"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                modelValue: _ctx.updateModel.address,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.updateModel.address) = $event)),
                modelModifiers: { trim: true },
                autocomplete: "off",
                placeholder: "请输入地址",
                maxlength: "30"
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "状态",
            prop: "serviceCode"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$filters.statusFormat(_ctx.customer.status)), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "资源地区",
            prop: "serviceCode"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.customer.serviceCode), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "角色",
            prop: "accessGroup"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.updateModel.accessGroup,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.updateModel.accessGroup) = $event)),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessGroups, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "备注",
            prop: "remark"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                modelValue: _ctx.updateModel.remark,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.updateModel.remark) = $event)),
                autocomplete: "off",
                placeholder: "请输入备注",
                maxlength: "50"
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "创建时间",
            prop: "creationDate"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$filters.dateFormat(_ctx.customer.creationDate)), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.save
              }, {
                default: _withCtx(() => [
                  _createTextVNode("保存")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.goBack
              }, {
                default: _withCtx(() => [
                  _createTextVNode("返回上一级")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["model", "rules"])
    ])
  ]))
}